var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:this.$route.name,attrs:{"id":"app"}},[_c('AppHeader'),_c('transition',{attrs:{"name":"slide","mode":"out-in"}},[_c('router-view')],1),_c('FriendsModal'),_c('PoliciesModal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }